import React, { useState, useContext, useEffect } from 'react'
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';
import { Typeahead } from 'react-bootstrap-typeahead';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link } from 'react-router-dom';


const Contact = ( { label, db, value, org, aid, uid, contacts, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ singleSelections, setSingleSelections ] = useState( [] );
    const [ loaded, setLoaded ] = useState( false );
    const [ searchList, setSearchList ] = useState( [] );

    useEffect( () => {
        let list = [];
        if ( contacts ) {
            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];

                if ( aid === c.aid || ( org && org.sharePartners === true && c.shared === true ) ) {
                    list.push( {
                        id: c.cid,
                        cid: c.cid,
                        firstname: c.firstname,
                        lastname: c.lastname,
                        name: c.name,
                        email: c.email,
                        team: c.team,
                        employer: c.employer,
                        priRole: c.priRole
                    } );
                }
            } );
        }
        setSearchList( list );
    }, [ contacts, aid, uid ] );

    useEffect( () => {
        if ( value ) {
            const c = contacts[value];
            if ( c !== undefined ) {
                setSingleSelections( [ c ] );
            }
        }
    }, [ value, contacts ] );

    useEffect( () => {
        if ( loaded ) {
            let v;

            if ( singleSelections.length ) {
                const c = contacts[singleSelections[0].cid];
                if ( c ) {
                    v = c.cid;
                }
            }

            setDraftValues( prevState => (
                {
                    ...prevState,
                    [db]: v
                }
            ) );
        } else {
            // initial load has every value undefined - skip it
            setLoaded( true );
        }
    }, [ singleSelections, contacts, db, setDraftValues, loaded ] );

    
    return (
        <Col className='tf-obj-data-element align-items-center'>
            <Form.Group as={Row} className='tf-form-group' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col className='tf-form-text-field me-1'>
                    <Row className='align-items-center'>
                        <Col>
                            <Typeahead
                                id={`${formId}-${db}`}
                                filterBy={ [ 'firstname', 'lastname', 'email', 'team', 'employer', 'name' ] }
                                labelKey={ ( option ) => `${option.firstname} ${option.lastname}` }
                                onChange={setSingleSelections}
                                selected={singleSelections}
                                options={ searchList }
                                renderMenuItemChildren={ ( opt ) => (
                                    <Row>
                                        <Col>
                                            <Row className='align-items-center'>
                                                <Col xs='auto' className='pe-1'>
                                                    {
                                                        ( opt.priRole === 'borrower' ) ? (
                                                            <PersonIcon />
                                                        ) : (
                                                            <BusinessIcon />
                                                        )
                                                    }
                                                </Col>
                                                <Col className='ps-1'>
                                                    {opt.firstname + ' ' + opt.lastname}        
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                ) }
                                className='tf-typeahead-inline'
                            />
                        </Col>
                        {
                            ( value && value.length ) ? (
                                <Col xs='auto'><Link to={`/contact/${value}`}><LaunchIcon fontSize='small' /></Link></Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Col>
            </Form.Group>
        </Col>
    )
}

const mapProps = ( state ) => ( {
    org: state.user.org,
    // aid: state.user.aid,
    uid: state.user.email,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( Contact );